module.exports = __webpack_public_path__ + "assets/img/123.3223ac5e.png";